import { render, staticRenderFns } from "./BigButton.vue?vue&type=template&id=65627590&scoped=true"
import script from "./BigButton.vue?vue&type=script&lang=js"
export * from "./BigButton.vue?vue&type=script&lang=js"
import style0 from "./BigButton.vue?vue&type=style&index=0&id=65627590&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65627590",
  null
  
)

export default component.exports